<template>
  <div class="h-100 radius-15 bg-secondary">
    <div v-if="loading" class="col text-center">
      <div class="loader mx-auto p-5"></div>
    </div>
    <m-a target="_blank" v-else :href="findLinkOnContent(item.abstraction)">
      <img class="img-fluid radius-15" :src="item.thumbnail" :alt="item.name">
    </m-a>
  </div>
</template>

<script>

export default {
  name: "DashboardSlider1",
  data() {
    return {
      item: {},
      loading: true,
    }
  },
  props: {
    slug: {
      default: ""
    }
  },
  methods: {},
  async mounted() {
    this.item = await this.$store.dispatch('DashboardResource/getBanner', this.slug)
    this.item = this.item.data.data
    this.loading = false
  }
}
</script>

<style scoped>
.loader {
  width: 45px;
  height: 20px;
  background: linear-gradient(#0000 calc(1 * 100% / 6), #fff 0 calc(3 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(2 * 100% / 6), #fff 0 calc(4 * 100% / 6), #0000 0),
  linear-gradient(#0000 calc(3 * 100% / 6), #fff 0 calc(5 * 100% / 6), #0000 0);
  background-size: 10px 400%;
  background-repeat: no-repeat;
  animation: matrix 1s infinite linear;
}

@keyframes matrix {
  0% {
    background-position: 0% 100%, 50% 100%, 100% 100%
  }

  100% {
    background-position: 0% 0%, 50% 0%, 100% 0%
  }
}


</style>